import React from 'react'
import { DemoCTA } from 'newComponents'
import './styles.scss'

const TrialWithDemoButtons = () => (
  <div className="buttons-demo-trial-container">
    <DemoCTA primaryCta />
    <DemoCTA to="/contact-sales/" text="Contact Sales" eventName="Contact Sales Button Clicked" />
  </div>
)

export default TrialWithDemoButtons
